module.exports = __webpack_public_path__ + "img/a11y-cta-bg.90186fc.jpg";